import { baseStaticURL } from '@/lib/servies/axiosConfig';
import {
    ApiCity,
    ApiInsurance,
    ApiService,
    ApiSpecialty,
    AvailableFilters,
} from '@/types/filter';

export const fetchAvailableFiltersRequest = () =>
    fetch(`${baseStaticURL}/doctors_page`, {
        cache: 'no-cache',
        next: {
            // revalidate: 60 * 60 * 24,
            tags: ['doctors', 'filter', 'options'],
        },
    })
        .then((res) => res.json())
        .then(
            (data) =>
                ({
                    specialty: data.result.specialties.map(
                        (specialty: ApiSpecialty) => {
                            let prefix = '';
                            let currentParentId = specialty.parent_id;
                            while (true) {
                                const parent = data.result.specialties.find(
                                    (s: ApiSpecialty) =>
                                        s.id === currentParentId,
                                );

                                if (!parent) break;

                                prefix = `${parent.name}/${prefix}`;
                                currentParentId = parent.parent_id;
                            }

                            return {
                                label: prefix + specialty.name,
                                value: specialty.slug,
                                api: specialty.id.toString(),
                            };
                        },
                    ),
                    // .sort(
                    //     (
                    //         a: {
                    //             label: string;
                    //             value: string;
                    //             url: string;
                    //         },
                    //         b: {
                    //             label: string;
                    //             value: string;
                    //             url: string;
                    //         }
                    //     ) => a.label.localeCompare(b.label)
                    // )
                    service: data.result.services.map(
                        (service: ApiService) => ({
                            label: service.name,
                            value: service.slug.toLowerCase(),
                            api: service.id.toString(),
                        }),
                    ),
                    city: data.result.cities.map((city: ApiCity) => ({
                        label: city.name + ' / استان ' + city.province.name,
                        value: city.slug.toLowerCase(),
                        province: city.province,
                        api: city.id.toString(),
                    })),

                    basicInsurance: data.result.basic_insurance
                        .filter(
                            (insurance: ApiInsurance) => insurance.type === '1',
                        )
                        .map((insurance: ApiInsurance) => ({
                            label: insurance.name,
                            value: insurance.slug.toString(),
                            api: insurance.id.toString(),
                        })),

                    supplementaryInsurance: data.result.basic_insurance
                        .filter(
                            (insurance: ApiInsurance) => insurance.type === '2',
                        )
                        .map((insurance: ApiInsurance) => ({
                            label: insurance.name,
                            value: insurance.slug.toString(),
                            api: insurance.id.toString(),
                        })),
                    type: [
                        {
                            label: 'درمانگاه',
                            value: 'clinic',
                            api: 'clinic',
                        },
                        {
                            label: 'بیمارستان',
                            value: 'hospital',
                            api: 'hospital',
                        },
                    ],
                } as AvailableFilters),
        );
